import React, { Fragment } from "react";
import secureBanner from "assets/images/YOOZ-Bill-Pay-Agent-Network-SECURITY-1440x465.png";
import ContentWrapper from "components/public-dashboard/components/contentWrapper";
import PageBanner from "components/public-dashboard/components/page_banner";
import PartnersContent from "./content";
import PartnersHeader from "./header";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";
 
export default function Partners() {
    useDocumentTitle(
    "Enhanced Security Measures | YOOZ",
    "YOOZ employs advanced security protocols and auditable processes, safeguarding your data from beginning to end. Find out how YOOZ protects your transactions."
  );

  return (
    <Fragment>
      <PageBanner img={secureBanner} />
      <ContentWrapper>
        <PartnersHeader />
        <PartnersContent />
      </ContentWrapper>
    </Fragment>
  );
}
